import * as routes from './routes';

export const ROUTES = {
  ...routes
};
export { default as AppRouter } from './app-router';
